/* eslint-disable default-param-last */
/**
 * @description Reducer sobre as funções em comum entre os exames realizados
 * @author Diego Sabino Amorim de Araújo
 * @file edicaoExame/exameRealizadoReducer.js
 *
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

const initialState = {
  vestigiosIdentificados: [],
}

const exameRealizadoReducer = (state = initialState, action) => {
  switch (action.type) {
    default: {
      return {
        ...state,
      }
    }
  }
}

export default exameRealizadoReducer
